import React from 'react';

interface DpiWarningProps {
  warning: {
    level: 'error' | 'warning' | 'info' | 'success';
    message: string;
  } | null;
  calculatedDpi: number | null;
}

const DpiWarning: React.FC<DpiWarningProps> = ({ warning, calculatedDpi }) => {
  if (!warning) return null;

  const getIcon = () => {
    switch (warning.level) {
      case 'error':
        return 'fa-exclamation-triangle';
      case 'warning':
        return 'fa-exclamation-circle';
      case 'info':
        return 'fa-info-circle';
      case 'success':
        return 'fa-check-circle';
      default:
        return 'fa-info-circle';
    }
  };

  return (
    <div className={`dpi-warning dpi-warning-${warning.level}`}>
      <i className={`fas ${getIcon()}`}></i>
      <div className="dpi-warning-content">
        <strong>Image Quality: {calculatedDpi ? `${calculatedDpi.toFixed(0)} DPI` : 'Calculating...'}</strong>
        <p>{warning.message}</p>
      </div>
    </div>
  );
};

export default DpiWarning;
